export const handleChangeDataModalAddAddress = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_ADD_ADDRESS', name, value
});